import React from "react";
import { Card, CardContent } from "@/components/ui/card";
import Loader from "@/components/ui/Loader";
import { getCoreRowModel, useReactTable } from "@tanstack/react-table";
import EmptyDatas from "components/ui/EmptyDatas";
import Table from "components/ui/my-data-table";
import useSWR from "swr";
import { columns } from "./data-table-column";

export const ToningsTab = () => {
  const { data, isLoading, isValidating } = useSWR(["/spine-tonings"]);

  const table = useReactTable({
    data: data || [],
    columns,
    enableRowSelection: false,
    getRowId: (row) => (row.id ? String(row.id) : String(row.index)),
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className="h-[calc(100vh-150px)]">
      {isLoading || isValidating ? (
        <Loader>加载全局调色方案...</Loader>
      ) : !data ? (
        <EmptyDatas />
      ) : (
        <Card className="h-full flex flex-col">
          <CardContent className="flex-1 overflow-hidden pb-0 overflow-y-auto pt-4">
            <Table table={table} />
          </CardContent>
        </Card>
      )}
    </div>
  );
};

